import IpubModel from './src/main'

/* istanbul ignore next */
IpubModel.install = function(Vue) {
  Vue.component(IpubModel.name, IpubModel)
}

export default IpubModel
